import { ref, computed, watch } from 'vue'
import { useTheme as useVuetifyTheme } from 'vuetify'

export function useTheme() {
  const vuetifyTheme = useVuetifyTheme()
  const theme = ref(localStorage.getItem('theme') ?? 'light')

  watch(theme, (newTheme) => {
    localStorage.setItem('theme', newTheme)
    vuetifyTheme.global.name.value = newTheme
  })

  vuetifyTheme.global.name.value = theme.value

  const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
    localStorage.setItem('theme', theme.value)
  }

  const isDark = computed(() => theme.value === 'dark')

  const setThemeBasedOnSystem = () => {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    theme.value = prefersDark ? 'dark' : 'light'
  }

  return {
    isDark,
    toggleTheme,
    theme,
    setThemeBasedOnSystem
  }
} 